var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangerTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45608 20.2209L13.9997 12.5251L25.5433 20.2209C26.3665 20.7697 25.978 22.0529 24.9886 22.0529H3.01078C2.02138 22.0529 1.63285 20.7697 2.45608 20.2209Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6182 8.55528C11.6182 7.23977 12.6846 6.17334 14.0001 6.17334C15.3156 6.17334 16.3821 7.23977 16.3821 8.55528C16.3821 9.8708 15.3156 10.9372 14.0001 10.9372V12.5252",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangerTip);
export default __webpack_public_path__ + "static/media/hanger_tip.414af656e212c84b470e0e96be901ccc.svg";
export { ForwardRef as ReactComponent };